export default __webpack_public_path__ + "static/facilities-img2-867c86692dc8e2c9975ba7a2a110f915.png";